var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FFC411",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 29.9999C14 21.1634 21.1634 14 30.0001 14C38.8366 14 46 21.1634 46 29.9999C46 38.8366 38.8366 46 30.0001 46C21.1634 46 14 38.8366 14 29.9999Z",
    fill: "url(#paint0_linear_562_3046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7644 26.8965C24.2364 26.8965 23.8084 26.4685 23.8084 25.9407V25.6496C23.8084 25.1576 23.4083 24.7574 22.9162 24.7574C22.4244 24.7574 22.0243 25.1576 22.0243 25.6496V25.9407C22.0243 26.4685 21.5963 26.8965 21.0683 26.8965C20.5403 26.8965 20.1123 26.4685 20.1123 25.9407V25.6496C20.1123 24.1036 21.3702 22.8457 22.9162 22.8457C24.4625 22.8457 25.7201 24.1036 25.7201 25.6496V25.9407C25.7201 26.4685 25.2921 26.8965 24.7644 26.8965Z",
    fill: "#282D35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1311 26.6162C37.6031 26.6162 37.1751 26.1882 37.1751 25.6605V25.3693C37.1751 24.8773 36.7749 24.4771 36.2829 24.4771C35.7911 24.4771 35.391 24.8773 35.391 25.3693V25.6605C35.391 26.1882 34.963 26.6162 34.435 26.6162C33.907 26.6162 33.479 26.1882 33.479 25.6605V25.3693C33.479 23.8233 34.7369 22.5654 36.2829 22.5654C37.8292 22.5654 39.0868 23.8233 39.0868 25.3693V25.6605C39.0868 26.1882 38.6588 26.6162 38.1311 26.6162Z",
    fill: "#282D35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1122 31.8478C21.7192 31.8478 23.0218 31.2298 23.0218 30.4674C23.0218 29.705 21.7192 29.0869 20.1122 29.0869C18.5053 29.0869 17.2026 29.705 17.2026 30.4674C17.2026 31.2298 18.5053 31.8478 20.1122 31.8478Z",
    fill: "#F97E58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5722 31.8478C41.1791 31.8478 42.4818 31.2298 42.4818 30.4674C42.4818 29.705 41.1791 29.0869 39.5722 29.0869C37.9653 29.0869 36.6626 29.705 36.6626 30.4674C36.6626 31.2298 37.9653 31.8478 39.5722 31.8478Z",
    fill: "#F97E58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9309 39.7602C26.6878 39.7602 24.0493 37.1217 24.0493 33.8786C24.0493 33.5827 24.2892 33.3428 24.585 33.3428H35.2766C35.5726 33.3428 35.8125 33.5827 35.8125 33.8786C35.8125 37.1217 33.174 39.7602 29.9309 39.7602Z",
    fill: "#282D35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9309 35.4609C28.1988 35.4609 26.5783 36.2111 25.3584 37.5743C26.4376 38.9071 28.0863 39.7609 29.9309 39.7609C31.7754 39.7609 33.4242 38.9071 34.5034 37.5743C33.2835 36.2111 31.6629 35.4609 29.9309 35.4609Z",
    fill: "url(#paint1_linear_562_3046)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_562_3046",
    x1: 14,
    y1: 30,
    x2: 46,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_562_3046",
    x1: 25.3584,
    y1: 37.6109,
    x2: 34.5034,
    y2: 37.6109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#D43917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7208,
    stopColor: "#C62C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.c02cb0ea6e80f1714c15d4fe3ab94e11.svg";
export { ForwardRef as ReactComponent };